import { useAppContext } from '@/context/AppContext';
import { TIMESHEETS } from '@/data/timesheets';
import type { TimesheetBundle } from '@/data/timesheets';

interface UseTimesheetsResult {
  data: Record<string, TimesheetBundle>;
  isLoading: boolean;
}

export function useTimesheets(): UseTimesheetsResult {
  const { mockupMode } = useAppContext();
  if (mockupMode) return { data: TIMESHEETS, isLoading: false };
  // Timesheet data requires composing workblocks-range per employee — deferred
  return { data: {}, isLoading: false };
}
